import { mygooruSerializer } from '@/providers/serializers/mygooru/mygooru';
import { http } from '../http';

export class MygooruAPI {

    private static INSTANCE = new MygooruAPI();

    private namespace: string = 'api/v1/nlt/analytics/reports';
    private nltAnalyticNamespace: string = 'api/v1/nlt/analytics/';

    static get instance() {
        return this.INSTANCE;
    }

    public async fetchActiveUsersTrends(params: any) {
        const endpoint = `${this.namespace}/active-users`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return mygooruSerializer.normalizeReportsData(response.data);
        });
    }

    public async fetchAverageSession(params: any) {
        const endpoint = `${this.namespace}/average-session`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return mygooruSerializer.normalizeReportsData(response.data);
        });
    }

    public async fetchNudgeAverageTimeSpent(params: any) {
        const endpoint = `${this.namespace}/nudge-usage`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return mygooruSerializer.normalizeReportsData(response.data);
        });
    }

    public async fetchNudgeInteractions(params: any) {
        const endpoint = `${this.namespace}/nudge-interaction`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return mygooruSerializer.normalizeReportsData(response.data);
        });
    }

    public async fetchNudgeFeedback(params: any) {
        const endpoint = `${this.namespace}/nudge-feedback`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return mygooruSerializer.normalizeReportsData(response.data);
        });
    }

    public async fetchTenantUserTypes() {
        const endpoint = `${this.nltAnalyticNamespace}tenant/user-types`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    public async fetchUserLevelReport(params: any) {
        const endpoint = `${this.namespace}/user-level`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return response.data;
        });
    }
}
export const mygooruAPI = MygooruAPI.instance;
